export const data = [{
    id: "1",
    name: "upaltino",
    title: "UP Altino",
    city: "Osasco",
    neighborhood: "Presidente Altino",
    summary: "3 e 2 Dorms (suíte) de 69m² e 60m², coberturas duplex de 4 e 3 dorms, próximo à estação de trem e grandes shopping de Osasco",
    image_url: "assets/img/upaltino/upaltino3.jpg",
    image_alt: "Up Altino",
    address: "Rua Ana Zozi Toni, 366",
    place_id: "ChIJyzg3FTz_zpQR2adp_zazwbw",
    price: "R$ 420.000,00",
    price_description:"3 dorms c/ suíte 2 vagas a partir de",
    video_url: "",
    banner_url: "assets/img/upaltino/upaltino_banner.jpg",
    property_details: [{ car: "1 ou 2 vagas"}, {air_conditioning: ""}, {balcony: "Terraço Grill"}],
    property_options: [
        {
            options_id: "1",
            type: "duplex", 
            bedroom: "4 Quartos (3 suítes)",
            washroom: "4 banheiros (total)",
            extras: []
        },
        {
            options_id: "2",
            type: "duplex", 
            bedroom: "3 Quartos (2 suítes)",
            washroom: "3 banheiros (total)",
            extras: [] 
        }, 
        {
            options_id: "3",
            type: "", 
            bedroom: "3 Quartos (1 suíte)",
            washroom: "3 banheiros (total)",
            extras: [] 
        },
        {
            options_id: "4",
            type: "", 
            bedroom: "2 Quartos (1 suíte)",
            washroom: "3 banheiros (total)",
            extras: []
            
        },
    ],
    property_amenities: ["piscinas adulto com raia e infantil", "deck molhado", "quadra esportiva", "fitness", "playground", "brinquedoteca", "salão de jogos", "salão de festas", "espaço gourmet", "churrasqueira com forno de pizza", "espelho d'água com cascata", "praça de convivência", "solarium"],
    description: "Apartamento pronto para morar, à 200m da estação Presidente Altino da CPTM, próximos aos grandes shoppings de Osasco, 10 minutos de carro do parque Villa Lobos é condomínio clube com lazer completo com um custo benefício inigualável, agende uma visita e conheça um dos empreedimentos referência em Presidente Altino", 
    links: ["http://zafirconstrutora.com.br/empreendimentos/up-altino/", "http://www.upaltino.com.br/"],
  },
  {
    id: "2",
    name: "vitralaltino",
    title: "Vitral Altino",
    city: "Osasco",
    neighborhood: "Presidente Altino",
    summary: "2 ou 1 Dorms (com suíte e penthouse), em ótima localização e com o melhor do lazer",
    image_url: "assets/img/vitralaltino/vitralaltino1.jpg",
    image_alt: "Vitral Altino",
    address: "Rua Erasmo Braga, 637",
    place_id: "ChIJh1oQHhb_zpQR66R4o0irK18",
    price: "R$ 270.000,00",
    price_description:"2 dorms 1 vaga chave p/ Março 2019 a partir de",
    video_url: "",
    banner_url: "assets/img/vitralaltino/vitralaltino_banner.jpg",
    property_details: [{ car: "1 vaga"}, {air_conditioning: ""}, {balcony: ""}],
    property_options: [
        {
            options_id: "1",
            type: "78 m² ou 73m² com Penthouse suíte", 
            bedroom: "2 Dormitórioss (1 suíte)",
            washroom: "3 banheiros (total)",
            extras: []
        },
        {
            options_id: "2",
            type: "74 m² ou 69 m² com Penthouse", 
            bedroom: "2 Dormitórios",
            washroom: "2 banheiros",
            extras: [] 
        }, 
        {
            options_id: "3",
            type: "51 m²", 
            bedroom: "2 Dormitórios",
            washroom: "2 banheiros",
            extras: [] 
        },
        {
            options_id: "4",
            type: "48 m²", 
            bedroom: "2 ou 1 Dormitório(s) ",
            washroom: "1 banheiro",
            extras: []
            
        },
    ],
    property_amenities: ["Home Office", "Fitness", "Bicicletário", "Salão de Festas Adulto", "Salão de Festas Infantil", 
    "Salão de Jogos Adulto", "Salão de Jogos Infantil", "Pet PLace", "Meeting Home", "Quadra Esportiva", "Piscina Adulto e Infantil", "Solarium", "Deck Molhado", "Playground", "Espaço Gourmet na Cobertura", "Pergolados", "Brinquedoteca"],
    description: "Uma das localizações mais privilegiadas de Osasco para condomínios residenciais, pelas inúmeras facilidades ao seu redor, entre elas, fáceis acessos a outras regiões graças à proximidade com avenidas e rodovia, assim como com a estação Presidente Altino da CPTM, ótima oferta de comércio, como o Walmart, shopping, etc. Condomínio com lazer completo e várias opções de apartamentos.", 
    links: ["http://zafirconstrutora.com.br/empreendimentos/vitral-altino/"],
  },{
    id: "3",
    name: "atriobelavista",
    title: "Atrio Bela Vista",
    city: "Osasco",
    neighborhood: "Bela Vista",
    summary: "2 Dorms (suíte) de 56m² a 67m², depósito privativo e vaga livre, com o melhor preço da região da Bela Vista - Osasco",
    image_url: "assets/img/atriobelavista/atriobelavista1.jpg",
    image_alt: "Atrio Bela Vista",
    address: "Av. Cesar Abraão, 268",
    place_id: "ChIJx8LaoqD_zpQRaKhoVAZeWPk",
    price: "R$ 320.000,00",
    price_description:"2 dorms 1 vaga + depósito a partir de",
    video_url: "https://www.youtube.com/embed/18gilG1bPPM",
    banner_url: "assets/img/atriobelavista/atriobelavista_banner.jpg",
    property_details: [{ car: "vaga coberta e livre com depósito privativo"}, {air_conditioning: "Suíte"}, {balcony: ""}],
    property_options: [
        {
            options_id: "1",
            type: "Penthouse", 
            bedroom: "3 Dormitórios (2 suítes)",
            washroom: "3 (total)",
            extras: []
        },
        {
            options_id: "2",
            type: "Penthouse com Sala Ampliada", 
            bedroom: "2 Suítes",
            washroom: "3 banheiros (total)",
            extras: [] 
        }, 
        {
            options_id: "3",
            type: "56m² (ponta e meio)", 
            bedroom: "2 (1 Suíte)",
            washroom: "2 banheiros (total)",
            extras: [] 
        }
    ],
    property_amenities: ["Piscina Adulto com Raia e Borda Infinita", "Piscina Infantil", "Deck Molhado", "Fitness", "Quadra Recreativa", 
    "Salão de Festas Adulto integrado ao Espaço Gourmet", "Salão de Festas Infantil",  "Salão de Jogos Adulto", 
    "Salão de Jogos Teen", "Espaço Lounge", "Playground",  "Brinquedoteca",  "Espaço Família",  "Pergolado"],
    description: "Atrio Bela Vista Osasco é uma concepção residencial com um novo conceito em moradia para quem busca boa localização, segurança, privacidade, conforto e qualidade de vida. Viva em um apartamento confortável com várias opções de lazer e toda infraestrutura de um grande empreendimento em lançamento.", 
    links: ["http://www.atriobelavista.com.br/", "http://zafirconstrutora.com.br/empreendimentos/atrio-bela-vista/"],
  },{
    id: "4",
    name: "portalvistallegro",
    title: "Portal Vistallegro",
    city: "Osasco",
    neighborhood: "Quitaúna",
    summary: "2 e 1 Dorms com 1 vaga livre, Minha Casa Minha Vida, com clube, segurança e bem-estar em 11.000m² de terreno e mais de 20 itens de lazer",
    image_url: "assets/img/portalvistallegro/portalvistallegro1.jpg",
    image_alt: "Portal Vistallegro",
    address: "Av. José Barbosa de Siqueira, 1805",
    place_id: "ChIJgTQUgM__zpQRkVYwT1aQObQ", 
    price: "R$ 215.000,00",
    price_description:"Pronto para morar a partir de",
    video_url: "",
    banner_url: "assets/img/portalvistallegro/portalvistallegro_banner.jpg",
    property_details: [{ car: "1 vaga"}, {air_conditioning: ""}, {balcony: ""}],
    property_options: [
        {
            options_id: "1",
            type: "", 
            bedroom: "2 Dormitórios",
            washroom: "1 Banheiro",
            extras: []
        },
        {
            options_id: "2",
            type: "", 
            bedroom: "1 Dormitório",
            washroom: "1 Banheiro",
            extras: [] 
        }
    ],
    property_amenities: ["Piscina Adulto", "Piscina Infantil", "Deck Molhado", "Fitness", "Área de descanso", "Vestiários", "Pet Place", 
    "Mini Golfe", "Pergolados", "Festas Infantil",  "Festas Adulto",  "Jogos / Brinquedoteca", "Espaço Família I e II", 
    "Praça",  "Playground I e II", "Quadra Esportiva", "Street Ball", "Chute a Gol", "Bicicletário"],
    description: "Morar em uma região tranquila, e de ter a sua volta uma completa infra-instrutora de comércio e serviços, com shopping, escolas, bancos, farmácias, padarias, centros comerciais e muito mais, segurança de um condomínio fechado para você e sua família curtirem a vida com total tranqüilidade.", 
    links: ["http://portalvistallegro.com.br/", "http://zafirconstrutora.com.br/empreendimentos/portal-vistallegro/"],
  },{
    id: "5",
    name: "parquecentralreserva",
    title: "Parque Central Reserva",
    city: "Osasco",
    neighborhood: "Centro",
    summary: "2 Dorms, com opção de suíte e terraço gourmet, com localização privilegiada com itens de lazer e diversão para a família toda",
    image_url: "assets/img/parquecentralreserva/parquecentralreserva1.jpg",
    image_alt: "Parque Central Reserva",
    address: "Rua Prof. Luis Eulálio de Bueno Vidigal, 175",
    place_id: "ChIJkfjTxAP_zpQRDKYqlr7HS2Y",
    price: "R$ 255.000,00",
    price_description:"2 dorms 1 vaga a partir de", 
    video_url: "",
    banner_url: "assets/img/parquecentralreserva/parquecentralreserva_banner.jpg",
    property_details: [{ car: ""}, {air_conditioning: ""}, {balcony: "Terraço Gourmet"}],
    property_options: [
        {
            options_id: "1",
            type: "52.70m²", 
            bedroom: "2 Dormitórios (1 Suíte)",
            washroom: "2 Banheiros (total)",
            extras: []
        },
        {
            options_id: "2",
            type: "48.50m² ou 44m² meio ou ponta", 
            bedroom: "2 Dormitórios",
            washroom: "1 Banheiro",
            extras: [] 
        }
    ],
    property_amenities: ["Portaria", "Piscina Infantil", "Piscina Adulto", "Deck Molhado", "Fitness", "Home Office", "Praça Entre Torres", "Espeço Beleza", "Espaço Gourmet", "Playground", "Pista de Caminhada", "Pet Place", "Brinquedoteca", "Salão de Jogos", "Espaço Jovem Externo", "Churrasqueira", "Quadra esportiva", "Pista Caminhada/Bosque", "Salão de Festas Adulto", "Salão de Festas Infantil"],
    description: "Numa região de Osasco voltada para moradia, com vários condomínios já ali implantados, próximo dos principais acessos às outras regiões da cidade e também para São Paulo e interior. Além disso, com a facilidade de ter a estação Osasco da CPTM a poucos metros de distância. Condomínio com ótima área de lazer e boas opções de apartamentos.", 
    links: ["http://www.parquecentralreserva.com.br/", "http://zafirconstrutora.com.br/empreendimentos/parque-central-reserva/"],
  },
  {
    id: "6",
    name: "boulevardparquecentral",
    title: "Boulevard Parque Central",
    city: "Osasco",
    neighborhood: "Centro",
    summary: "2 e 1 Dorms, com opção de suíte e terraço gourmet, excelente localização, more em um condomínio com mais de 12.000m² com lazer completo",
    image_url: "assets/img/boulevardparquecentral/boulevardparquecentral1.jpg",
    image_alt: "Boulevard Parque Central",
    address: "R. Prof. Luis Eulálio de Bueno Vidigal, 137",
    place_id: "ChIJq4RJGcD_zpQRD7TfqUkxAZA",
    price: "R$ 230.000,00",
    price_description:"2 dorms 1 vaga a partir de",
    video_url: "",
    banner_url: "assets/img/boulevardparquecentral/boulevardparquecentral_banner.jpg",
    property_details: [{ car: "1 vaga"}, {air_conditioning: ""}, {balcony: ""}],
    property_options: [
        {
            options_id: "1",
            type: "52m² com terraço", 
            bedroom: "2 Dormitórios (1 Suíte)",
            washroom: "2 Banheiros (total)",
            extras: []
        },
        {
            options_id: "2",
            type: "53.20m²,  50.50m²,  48.50m² com terraço", 
            bedroom: "2 Dormitórios",
            washroom: "1 Banheiro",
            extras: [] 
        }, 
        {
            options_id: "3",
            type: "44m²", 
            bedroom: "2 Dormitórios",
            washroom: "1 Banheiro",
            extras: [] 
        },
        {
            options_id: "4",
            type: "45.20m², 42m², 39.90m², 36.60m² ou 32m² com terraço e/ou depósito", 
            bedroom: "1 Dormitório",
            washroom: "1 Banheiro",
            extras: []
            
        },
    ],
    property_amenities: ["Piscina Adulto", "Deck Molhado", "Sala de Jogos", "Espaço Mulher", "Sala de Yoga", "Home Office", "Briquedoteca", "Espaço Gourmet", "Churrasqueiras",
  "Pet Place", "Pergolado de Festas", "Playground I", "Playground II", "Pergolado do Sol", "Quadra Esportiva  ", "Campo de Futebol", "Espaço Aventura", "Lounge", "Master Fitness", 
  "Pista de Cooper", "Bicicletário", "Salão de Festas Adulto e Infantil"],
    description: "Aqui sua vida vai mudar. Lazer completo para a diversão de toda a família. Praça entre torres com pergolados, jogos, espaço jovem externo, playground, brinquedoteca, espaço gourmet, espaço beleza, massagem, ginástica, meeting point, piscinas adultos e infantil, solarium, salão de festas adulto e infantil, pista caminhada (bosque), espaço pet, bicicletário, churrasqueiras, quadra esportiva. Localização que próxima as maiores facilidades: escola, hospital, estação de trem, ponto de ônibus, shopping, supermercado", 
    links: ["http://www.boulevardparquecentral.com.br/", "http://zafirconstrutora.com.br/empreendimentos/boulevard-parque-central/"],
  },
  {
    id: "7",
    name: "questcampesina",
    title: "Quest Campesina",
    city: "Osasco",
    neighborhood: "Campesina",
    summary: "3, 2 ou 1 Dorm, com opção de suíte e terraço gourmet e 1 ou 2 vagas, a segurança de um condomínio fechado recheado de muito lazer, pronto para morar",
    image_url: "assets/img/questcampesina/questcampesina1.jpg",
    image_alt: "Quest Campesina",
    address: "Rua Manoel Saraiva, 45 ",
    place_id: "ChIJ2w8gv2v_zpQRdvaT-iFca2k",
    price: "R$ 230.000,00",
    price_description:"Últimas unidades em PROMOÇÃO a partir de",
    video_url: "",
    banner_url: "assets/img/questcampesina/questcampesina_banner.jpg",
    property_details: [{ car: "1 ou 2 vagas"}, {air_conditioning: ""}, {balcony: ""}],
    property_options: [
        {
            options_id: "1",
            type: "Entre em contato para maiores detalhes!", 
            bedroom: "",
            washroom: "",
            extras: []
        },
    ],
    property_amenities: ["Churrasqueira", "Solarium", "Sauna", "Fitness", "Office", "Playground", "Salão de Jogos", "Lavanderia", "Piscina", "Forno de Pizza", "Salão de Festas",  "Espaço Gourmet", "Bicicletário", "Descanso", "Gazebo Gourmet", "Concierge com pay-per-use"],
    description: "O empreendimento está em meio a uma das regiões que mais se valoriza em Osasco. Quest é dotado de um estilo arquitetônico moderno que se destaca na paisagem. A fachada transmite toda elegância do conjunto, além da infraestrutura completa e do belíssimo paisagismo.Os apartamentos são amplos, bem distribuídos e funcionais, em cada planta você obtém o máximo em bem-estar e conforto.", 
    links: [""],
  },
  ]

  export default {data}


  export const upaltino = [{
    original: '/assets/img/upaltino/upaltino1.jpg',
    description: 'Fachada',
    thumbnail:'/assets/img/upaltino/upaltino1_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino2.jpg',
    description: 'Sala de Estar 1',
    thumbnail:'/assets/img/upaltino/upaltino2_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino3.jpg',
    description: 'Sala de Estar 2',
    thumbnail:'/assets/img/upaltino/upaltino3_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino4.jpg',
    description: 'Sala de Estar 3',
    thumbnail:'/assets/img/upaltino/upaltino4_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino5.jpg',
    description: 'Piscina',
    thumbnail:'/assets/img/upaltino/upaltino5_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino6.jpg',
    description: 'Salão de Festas',
    thumbnail:'/assets/img/upaltino/upaltino6_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino7.jpg',
    description: 'Churrasqueira',
    thumbnail:'/assets/img/upaltino/upaltino7_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino8.jpg',
    description: 'Brinquedoteca',
    thumbnail:'/assets/img/upaltino/upaltino8_thumb.jpg',   
},{
    original: '/assets/img/upaltino/upaltino9.jpg',
    description: 'Quadra',
    thumbnail:'/assets/img/upaltino/upaltino9_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino10.jpg',
    description: 'Pergolado',
    thumbnail:'/assets/img/upaltino/upaltino10_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino11.jpg',
    description: 'Entrada',
    thumbnail:'/assets/img/upaltino/upaltino11_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino12.jpg',
    description: 'Playground',
    thumbnail:'/assets/img/upaltino/upaltino12_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino13.jpg',
    description: 'Fitness',
    thumbnail:'/assets/img/upaltino/upaltino13_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino14.jpg',
    description: 'Planta Tipo - 3 dorms - Sala Ampliada',
    thumbnail:'/assets/img/upaltino/upaltino14_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino15.jpg',
    description: 'Planta Tipo - 3 dorms',
    thumbnail:'/assets/img/upaltino/upaltino15_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino16.jpg',
    description: 'Planta Tipo - 2 dorms - Sala Ampliada',
    thumbnail:'/assets/img/upaltino/upaltino16_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino17.jpg',
    description: 'Planta Tipo - 2 dorms',
    thumbnail:'/assets/img/upaltino/upaltino17_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino18.jpg',
    description: 'Planta Duplex Superior - 3 dorms',
    thumbnail:'/assets/img/upaltino/upaltino18_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino19.jpg',
    description: 'Planta Duplex Superior - 2 dorms',
    thumbnail:'/assets/img/upaltino/upaltino19_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino20.jpg',
    description: 'Planta Duplex Inferior - 3 dorms - Opção 4 dorms',
    thumbnail:'/assets/img/upaltino/upaltino20_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino21.jpg',
    description: 'Planta Duplex Inferior - 3 dorms',
    thumbnail:'/assets/img/upaltino/upaltino21_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino22.jpg',
    description: 'Planta Duplex Inferior - 2 dorms - Opção 2 suítes',
    thumbnail:'/assets/img/upaltino/upaltino22_thumb.jpg',   
},
{
    original: '/assets/img/upaltino/upaltino23.jpg',
    description: 'Planta Duplex Inferior - 2 dorms',
    thumbnail:'/assets/img/upaltino/upaltino23_thumb.jpg',   
}
]



export const vitralaltino = [{
    original: '/assets/img/vitralaltino/vitralaltino1.jpg',
    description: 'Perspectiva artística da sala',
    thumbnail:'/assets/img/vitralaltino/vitralaltino1_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino2.jpg',
    description: 'Vitral Piscina',
    thumbnail:'/assets/img/vitralaltino/vitralaltino2_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino3.jpg',
    description: 'Perspectiva artística da Praça',
    thumbnail:'/assets/img/vitralaltino/vitralaltino3_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino4.jpg',
    description: 'Perspectiva artística do Play Pergolado',
    thumbnail:'/assets/img/vitralaltino/vitralaltino4_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino5.jpg',
    description: 'Perspectiva artística da Quadra',
    thumbnail:'/assets/img/vitralaltino/vitralaltino5_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino6.jpg',
    description: 'Perspectiva artística do Salão de Jogos Adulto',
    thumbnail:'/assets/img/vitralaltino/vitralaltino6_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino7.jpg',
    description: 'Perspectiva artística do Home Office',
    thumbnail:'/assets/img/vitralaltino/vitralaltino7_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino8.jpg',
    description: 'Perspectiva artística do Salão de Jogos Juvenil',
    thumbnail:'/assets/img/vitralaltino/vitralaltino8_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino9.jpg',
    description: 'Perspectiva artística do Salão de Festas Adulto',
    thumbnail:'/assets/img/vitralaltino/vitralaltino9_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino10.jpg',
    description: 'Perspectiva artística da Churrasqueira',
    thumbnail:'/assets/img/vitralaltino/vitralaltino10_thumb.jpg',   
},{
    original: '/assets/img/vitralaltino/vitralaltino11.jpg',
    description: 'Perspectiva artística da Brinquedoteca',
    thumbnail:'/assets/img/vitralaltino/vitralaltino11_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino12.jpg',
    description: 'Perspectiva artística do Bicicletario',
    thumbnail:'/assets/img/vitralaltino/vitralaltino12_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino13.jpg',
    description: 'Perspectiva artística do Atelier Infantil',
    thumbnail:'/assets/img/vitralaltino/vitralaltino13_thumb.jpg',   
},
{
    original: '/assets/img/vitralaltino/vitralaltino14.jpg',
    description: 'Perspectiva artística da Festas Infantil',
    thumbnail:'/assets/img/vitralaltino/vitralaltino14_thumb.jpg',   
},{
    original: '/assets/img/vitralaltino/vitralaltino15.jpg',
    description: 'Perspectiva artística Fitness',
    thumbnail:'/assets/img/vitralaltino/vitralaltino15_thumb.jpg',   
},
]



export const atriobelavista = [{
    original: '/assets/img/atriobelavista/atriobelavista1.jpg',
    description: 'Terraço',
    thumbnail:'/assets/img/atriobelavista/atriobelavista1_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista2.jpg',
    description: 'Perspectiva artística Living Room',
    thumbnail:'/assets/img/atriobelavista/atriobelavista2_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista3.jpg',
    description: 'Perspectiva artística Living Room Penthouse',
    thumbnail:'/assets/img/atriobelavista/atriobelavista3_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista4.jpg',
    description: 'Perspectiva artística Terraço Penthouse',
    thumbnail:'/assets/img/atriobelavista/atriobelavista4_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista5.jpg',
    description: 'Perspectiva artística do Espaço Lounge',
    thumbnail:'/assets/img/atriobelavista/atriobelavista5_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista6.jpg',
    description: 'Perspectiva artística da Piscina Adulto com Raia e Borda Infinita',
    thumbnail:'/assets/img/atriobelavista/atriobelavista6_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista7.jpg',
    description: 'Perspectiva artística do Pergolado',
    thumbnail:'/assets/img/atriobelavista/atriobelavista7_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista8.jpg',
    description: 'Perspectiva artística do Playground',
    thumbnail:'/assets/img/atriobelavista/atriobelavista8_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista9.jpg',
    description: 'Perspectiva artística da Quadra',
    thumbnail:'/assets/img/atriobelavista/atriobelavista9_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista10.jpg',
    description: 'Perspectiva artística do Espaço Família',
    thumbnail:'/assets/img/atriobelavista/atriobelavista10_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista11.jpg',
    description: 'Perspectiva artística do Espaço Gourmet',
    thumbnail:'/assets/img/atriobelavista/atriobelavista11_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista12.jpg',
    description: 'Perspectiva artística da Brinquedoteca',
    thumbnail:'/assets/img/atriobelavista/atriobelavista12_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista13.jpg',
    description: 'Perspectiva artística do Fitness',
    thumbnail:'/assets/img/atriobelavista/atriobelavista13_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista14.jpg',
    description: 'Perspectiva artística do Salão de Jogos Adulto',
    thumbnail:'/assets/img/atriobelavista/atriobelavista14_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista15.jpg',
    description: 'Perspectiva artística do Salão de Jogos Adolescente',
    thumbnail:'/assets/img/atriobelavista/atriobelavista15_thumb.jpg',   
},
{
    original: '/assets/img/atriobelavista/atriobelavista16.jpg',
    description: 'Perspectiva artística do Salão de Festas Adulto',
    thumbnail:'/assets/img/atriobelavista/atriobelavista16_thumb.jpg',   
}
]



export const portalvistallegro= [{
    original: '/assets/img/portalvistallegro/portalvistallegro1.jpg',
    description: 'Living',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro1_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro2.jpg',
    description: 'Boulevard',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro2_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro3.jpg',
    description: 'Entrada',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro3_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro4.jpg',
    description: 'Perspectiva artística do Espaço Família',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro4_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro5.jpg',
    description: 'Perspectiva artística da Piscinas',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro5_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro6.jpg',
    description: 'Perspectiva artística do Street Ball',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro6_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro7.jpg',
    description: 'Perspectiva artística do Salão de Jogos',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro7_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro8.jpg',
    description: 'Perspectiva artística do Salão de Festas Infantil',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro8_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro9.jpg',
    description: 'Perspectiva artística do Salão de Festas Adulto',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro9_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro10.jpg',
    description: 'Perspectiva artística da Quadra',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro1_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro11.jpg',
    description: 'Perspectiva artística da Praça com Playground',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro11_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro12.jpg',
    description: 'Perspectiva artística do Pet Place',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro12_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro13.jpg',
    description: 'Perspectiva artística do Pergolado com jardim',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro13_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro14.jpg',
    description: 'Perspectiva artística do Mini Golf',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro14_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro15.jpg',
    description: 'Perspectiva artística Fitness e Descanso',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro15_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro16.jpg',
    description: '2 dorms. Tipo 1',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro16_thumb.jpg',   
},
{
    original: '/assets/img/portalvistallegro/portalvistallegro17.jpg',
    description: '2 dorms. Tipo 2',
    thumbnail:'/assets/img/portalvistallegro/portalvistallegro17_thumb.jpg',   
},
]


export const parquecentralreserva= [{
    original: '/assets/img/parquecentralreserva/parquecentralreserva1.jpg',
    description: '',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva1_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva2.jpg',
    description: 'Terraço',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva2_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva3.jpg',
    description: 'Quadra',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva3_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva4.jpg',
    description: 'Piscina',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva4_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva5.jpg',
    description: 'Festa Adulto',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva5_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva6.jpg',
    description: 'Espaço Gourmet',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva6_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva7.jpg',
    description: 'Pergolado',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva7_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva8.jpg',
    description: 'Espaço Pet',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva8_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva9.jpg',
    description: 'Pista de Caminhada',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva9_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva10.jpg',
    description: 'Fitness',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva10_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva11.jpg',
    description: 'Festas Infantil',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva11_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva12.jpg',
    description: 'Praça entre Torres',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva12_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva13.jpg',
    description: 'Espaço Beleza',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva13_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva14.jpg',
    description: 'Jogos',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva14_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva15.jpg',
    description: 'Playground',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva15_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva16.jpg',
    description: 'Home Office',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva16_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva17.jpg',
    description: 'Brinquedoteca',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva17_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva18.jpg',
    description: 'Churrasqueira',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva4_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva19.jpg',
    description: 'Bicicletário',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva19_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva20.jpg',
    description: 'Planta Tipo 2 dorm. c/ suíte e terraço - 52,70m²',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva20_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva21.jpg',
    description: 'Planta Tipo 2 dorm. c/ terraço - 48,50m² Ponta',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva21_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva22.jpg',
    description: 'Planta Tipo 2 dorm. c/ terraço - 48,50m² Meio',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva22_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva23.jpg',
    description: 'Planta Tipo 2 dorm. - 44m² Ponta',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva23_thumb.jpg',   
},
{
    original: '/assets/img/parquecentralreserva/parquecentralreserva24.jpg',
    description: 'Planta Tipo 2 dorm. - 44m² Meio',
    thumbnail:'/assets/img/parquecentralreserva/parquecentralreserva24_thumb.jpg',   
},
]

export const boulevardparquecentral= [{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral1.jpg',
    description: 'Perspectiva Artística do Terraço',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral1_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral2.jpg',
    description: 'Perspectiva artística do LIVING - 1 DORM',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral2_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral3.jpg',
    description: 'Perspectiva artística do LIVING do apto de 2 DORMS C/ TERRAÇO',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral3_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral4.jpg',
    description: 'Perspectiva artística do LIVING - 1 DORM',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral4_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral5.jpg',
    description: 'Perspectiva artística do TERRAÇO - 1 DORM',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral5_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral6.jpg',
    description: 'Perspectiva artística do TERRAÇO - 1 DORM',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral6_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral7.jpg',
    description: 'Perspectiva artística da Brinquedoteca',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral7_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral8.jpg',
    description: 'Perspectiva artística do Campo de Futebol',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral8_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral9.jpg',
    description: 'Perspectiva artística do Espaço Gourmet',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral9_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral10.jpg',
    description: 'Perspectiva artística do Master Fitness',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral10_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral11.jpg',
    description: 'Perspectiva artística do Gazebo ',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral11_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral12.jpg',
    description: 'Perspectiva artística do Home Office',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral12_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral13.jpg',
    description: 'Perspectiva artística do Bike Sharing',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral13_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral14.jpg',
    description: 'Perspectiva artística da Churrasqueira',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral14_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral15.jpg',
    description: 'Perspectiva artística do Espaço Mulher',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral15_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral16.jpg',
    description: 'Perspectiva artística da Portaria',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral16_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral17.jpg',
    description: 'Perspectiva artística da Quadra Poliesportiva',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral17_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral18.jpg',
    description: 'Perspectiva artística do Salao de Festas Adulto',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral18_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral19.jpg',
    description: 'Perspectiva artística do Salao de Festas Infantil',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral19_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral20.jpg',
    description: 'Perspectiva artística do Salao de Jogos',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral20_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral21.jpg',
    description: 'Perspectiva artística do Lounge Bar',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral21_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral22.jpg',
    description: 'Perspectiva artística da Sala de Yoga',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral22_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral23.jpg',
    description: 'Perspectiva artística do Play Baby',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral23_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral24.jpg',
    description: 'Perspectiva artística do Play Jovem',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral24_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral25.jpg',
    description: 'Perspectiva artística do Espaço Pet',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral25_thumb.jpg',   
},
{
    original: '/assets/img/boulevardparquecentral/boulevardparquecentral26.jpg',
    description: 'Perspectiva artística da Pista de Cooper',
    thumbnail:'/assets/img/boulevardparquecentral/boulevardparquecentral26_thumb.jpg',   
}
]


export const questcampesina= [{
    original: '/assets/img/questcampesina/questcampesina1.jpg',
    thumbnail:'/assets/img/questcampesina/questcampesina1_thumb.jpg',   
},
{
    original: '/assets/img/questcampesina/questcampesina2.jpg',
    thumbnail:'/assets/img/questcampesina/questcampesina2_thumb.jpg',   
},
{
    original: '/assets/img/questcampesina/questcampesina3.jpg',
    thumbnail:'/assets/img/questcampesina/questcampesina3_thumb.jpg',   
},
{
    original: '/assets/img/questcampesina/questcampesina4.jpg',
    thumbnail:'/assets/img/questcampesina/questcampesina4_thumb.jpg',   
},
{
    original: '/assets/img/questcampesina/questcampesina5.jpg',
    thumbnail:'/assets/img/questcampesina/questcampesina5_thumb.jpg',   
}
]


export const nogallery = [{
    original: '/assets/img/nogallery.jpg',
    thumbnail:'/assets/img/nogallery_thumb.jpg',   
}]

  


// WEBPACK FOOTER //
// ./src/const/data.js